var exports = {
  "W$": "MenuItem.module__subtext___TDQzdH",
  "z": "MenuItem.module__sliderItem___TDQzdH",
  "r9": "MenuItem.module__disabled___TDQzdH",
  "Ry": "MenuItem.module__sliderHeader___TDQzdH",
  "KF": "MenuItem.module__sliderLabel___TDQzdH",
  "rv": "MenuItem.module__sliderValue___TDQzdH",
  "xJ": "MenuItem.module__sliderContainer___TDQzdH",
};

module.exports = exports;
